import React from 'react';
import { Typography, Alert } from '@one-thd/sui-atomic-components';
var BarcodeAlert = function () {
    return (React.createElement("div", { className: "sui-mb-4", "data-testid": "barcode-alert" },
        React.createElement(Alert, { status: "error", size: "large" },
            React.createElement(Typography, null, "We had a technical issue and couldn\u2019t generate your barcode. Check again later or look for the barcode in your return instructions email."))));
};
export default BarcodeAlert;
